import {Stack, Typography} from '@mui/material';
import {animate} from 'motion/react';
import {translations} from 'presentation/translations-new';
import React, {useEffect, useState} from 'react';
import {CircularProgress} from './CircularProgress';
import {PROFILE_PROGRESS_THRESHOLDS} from './constants';
import {CompleteProfileCardContainer, StyledTypography} from './styles';
import {CompleteProfileCardProps} from './types';
import {useProfileSectionStore} from 'presentation/pages/private/profile/store/useProfileSection';

const {
	completeProfile,
	completeProfileDescription,
	completeProfileCompletedText,
	completeProfileCompleted,
} = translations['pt-br'].others.profileMenu;

export const CompleteProfileCard = ({percentage}: CompleteProfileCardProps) => {
	const [progressState, setProgressState] = useState(0);
	const setIsProfileCompleted = useProfileSectionStore(state => state.setIsProfileCompleted);

	const startAnimation = () => {
		setProgressState(0);

		setTimeout(() => {
			animate(0, percentage, {
				duration: 1.5,
				ease: 'easeOut',
				onUpdate: latest =>
					latest <= PROFILE_PROGRESS_THRESHOLDS.MAX && setProgressState(latest),
				onComplete: () =>
					percentage >= PROFILE_PROGRESS_THRESHOLDS.MAX && setIsProfileCompleted(true),
			});
		}, 50);
	};

	const isCompleted = percentage >= PROFILE_PROGRESS_THRESHOLDS.MAX;

	useEffect(() => {
		startAnimation();
	}, []);

	return (
		<CompleteProfileCardContainer>
			<Stack direction="row" spacing={2} alignItems="center">
				<CircularProgress progress={progressState} />

				<Stack flex={1}>
					<StyledTypography variant="body1" color="primary">
						{isCompleted ? completeProfileCompletedText : completeProfile}
					</StyledTypography>

					<Typography variant="caption" color="primary" lineHeight={1.43}>
						{isCompleted ? completeProfileCompleted : completeProfileDescription}
					</Typography>
				</Stack>
			</Stack>
		</CompleteProfileCardContainer>
	);
};
